import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RadioGroupValueChangeEvent, RadioOption } from './radio-group.types';
import { RadioOptionId } from './radio-group.types';
import { CheckboxValueChangeEvent } from '../checkbox/checkbox.types';

@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss'],
})
export class RadioGroupComponent<T> implements OnInit {
  @Input() public options: RadioOption<T>[] | null = null;
  @Input() public selectedOptionId: RadioOptionId | null = null;

  @Output() public optionSelected = new EventEmitter<
    RadioGroupValueChangeEvent<T>
  >();

  constructor() {}

  ngOnInit() {
    return;
  }

  onCheckboxValueChange(event: CheckboxValueChangeEvent): void {
    const isTryToUnselect = !event.checked;
    if (isTryToUnselect) {
      return;
    }
    const option = this.options?.find((o) => o.id === event.id);
    this.optionSelected.next({
      id: option?.id!,
      value: option?.value!,
    });
  }
}
